import React, { useEffect, useState } from 'react';
import { TextField, FormHelperText } from '@material-ui/core';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import { useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';

export const OwnershipGroupsDropdown = ({
  onChange,
  rawErrors,
  required,
  formData,
  schema,
}: FieldExtensionComponentProps<string>) => {
  const catalogApi = useApi(catalogApiRef);
  const title = schema.title || 'New Project Name';
  const [namespaces, setNamespaces] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNamespaces = async () => {
      try {
        // Get all Group, Component, and System entities from catalog
        const { items: entities } = await catalogApi.getEntities({
          filter: { kind: ['Group', 'Component', 'System'] },
        });

        // Extract unique namespaces from entities
        const uniqueNamespaces = new Set<string>();
        entities.forEach(entity => {
          if (
            entity.metadata.namespace &&
            entity.metadata.namespace !== 'default'
          ) {
            uniqueNamespaces.add(entity.metadata.namespace);
          }
        });

        setNamespaces(Array.from(uniqueNamespaces).sort());
      } catch (error) {
        console.error('Failed to fetch namespaces:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchNamespaces();
  }, [catalogApi]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  const namespaceExists = !!(formData && namespaces.includes(formData));
  const hasRequiredError = !!(rawErrors?.length && !formData);
  const isError = hasRequiredError || namespaceExists;

  return (
    <>
      <TextField
        label={title}
        margin="normal"
        required={required}
        error={isError}
        fullWidth
        value={formData || ''}
        onChange={handleChange}
        disabled={loading}
        helperText={
          loading
            ? 'Loading names...'
            : namespaceExists
            ? 'This name already exists on Backstage Catalog. Please type a different name.'
            : 'Enter a new name (a-z, 0-9, hyphens allowed, max 63 chars, case insensitive)'
        }
      />
      {hasRequiredError && (
        <FormHelperText error>This field is required</FormHelperText>
      )}
    </>
  );
};
